export enum EventType {
  REFER_LEAD = 1,
  ASSIGN_LEAD = 2,
  UPDATE_STATUS = 3,
  FUND_LEAD = 4,
  SHARE_LEAD = 5,
}

export interface AchievementProgress {
  event_type: number;
  event_type_name: string;
  event_type_label: string;
  progress: number;
}

export interface Achievement {
  id: number;
  event_type: number;
  event_type_name: string;
  milestone: number;
  title: string;
  description: string;
  active: boolean;
}

export interface AchievementConnection {
  id: number;
  achievement: Achievement;
  achieved_on: string;
}

export interface AchievementOverviewItem {
  id: number;
  event_type: number;
  event_type_name: string;
  milestone: number;
  title: string;
  description: string;
  earned: boolean;
  achieved_on: string | null;
  current_progress: number;
}

export interface AchievementsConnectionOverviewResponse {
  progress: AchievementProgress[];
  earned_achievements: AchievementConnection[];
  all_achievements: AchievementOverviewItem[];
}
